import { FC } from 'react';

const Tile: FC<{
  children: JSX.Element | JSX.Element[];
  className?: string;
}> = ({ children, className = '' }) => {
  return (
    <div
      className={`min-h-fit bg-white border rounded border-neutral-200 p-2.5 shadow-sm ${
        className || ''
      }`}
    >
      {children}
    </div>
  );
};

export default Tile;
